import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddressService } from './services/address.service';
import { AddressComponent } from './address/address.component';

import { RouterModule } from '@angular/router';


import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedTranslateLazyModule } from './shared-translate-lazy.module';
import { NgxMaskModule } from 'ngx-mask';


@NgModule({
  imports: [RouterModule,FormsModule,ReactiveFormsModule,CommonModule,SharedTranslateLazyModule,NgxMaskModule],
  declarations: [AddressComponent],

  exports: [AddressComponent,FormsModule,NgxMaskModule],
  providers: [AddressService]
})

export class AddressSharedModule { }
